import React, { ComponentProps } from "react";

interface ClickableProps extends Omit<ComponentProps<"div">, "role"> {
    cursor?: boolean;
    children: React.ReactNode;
}

export const ClickableDiv: React.FC<ClickableProps> = ({ cursor, children, ...props }) => {
    return React.createElement(
        "div",
        {
            tabIndex: 0,
            role: cursor ? "button" : "",
            ...props,
        },
        children
    );
};
